import React from 'react';

import RecipientsList from './RecipientsList';
import SelectOwner from './SelectOwner';

import permissionsOptions from '../permissions';

const Recipients = props => {
    const {
        recipientsInfo,
        newOwner,
        currentShare,
        onChangeOwner,
        onChangePermission,
        onRemoveRecipient,
        editable,
    } = props;

    return (
        <>
            <SelectOwner
                editable={editable}
                shareInfo={currentShare}
                recipientsInfo={currentShare.transferable_accounts}
                transferInProgress={currentShare.pending_ownership_change}
                newOwner={newOwner}
                onChange={onChangeOwner}
            />
            <div>
                <RecipientsList
                    editable={editable}
                    recipients={recipientsInfo.filter(
                        item => item.permissions !== 'owner'
                    )}
                    permissionsOptions={permissionsOptions}
                    onChange={onChangePermission}
                    onRemove={onRemoveRecipient}
                />
            </div>
        </>
    );
};

export default Recipients;
